import gql from "graphql-tag";
import { TRANSACTION_PNVT_FRAGMENT } from "./fragment";

export const ON_TRANSACTION_CREATE_OR_UPDATE = gql`
  subscription OnTransactionCreateOrUpdate($accountPaynovateId: Int) {
    onTransactionCreateOrUpdate(accountPaynovateId: $accountPaynovateId) {
      ...TransactionPnvtInfo
    }
  }
  ${TRANSACTION_PNVT_FRAGMENT}
`;
